import * as Yup from 'yup';
import axios from 'axios';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import { useCallback, useEffect, useRef, useState } from 'react';
import { capitalCase, sentenceCase } from 'change-case';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
import {
  Container, Grid, IconButton,
  Stack, Box, Button, TableRow,
  TableBody, Checkbox, Card,
  TableCell, Typography,
  TableContainer, Table,
  TablePagination,
  TextField,
  Switch,
  FormControlLabel,
  Autocomplete,
  Divider,
  Paper,
  Popover,
  CardHeader,
  TableHead,
  List,
  Menu,
  MenuItem,
  ListItemText,
  ListItem,
  Tabs,
  Tab,
  Tooltip,
  LinearProgress,
  Skeleton,
} from '@material-ui/core';
import { useTheme, experimentalStyled as styled, makeStyles } from '@material-ui/core/styles';
import plusFill from '@iconify/icons-eva/plus-fill';
// redux
import { LoadingButton, MobileDatePicker, MobileDateRangePicker } from '@material-ui/lab';
// routes
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Modal from '../../components/_dashboard/blog/ProjectModel';
import Label from 'src/components/Label';
import { useSnackbar } from 'notistack';
import { Delete, UploadFile, LocationOn, ExpandMore, ExpandLess, Remove, Add, PictureAsPdf, ViewModule, ViewList,List as ListIcon } from '@material-ui/icons';
import OfficialRequestSearch from 'src/components/_dashboard/official-request/OfficialRequestSearch';
import InfiniteScroll from 'react-infinite-scroll-component';
import OfficialCard from 'src/components/_dashboard/official-request/OfficialCard';
import Scrollbar from 'src/components/Scrollbar';
import moment from 'moment';
import { REST_API, REST_API_END_POINT, UNITS, currentFacilityId, filteredOtherFacilityTypes } from 'src/constants/Defaultvalues';
import { UploadAvatar, UploadMultiFile, UploadSingleFile } from 'src/components/upload';
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import LoadingScreen from 'src/components/LoadingScreen';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import UploadSingleFilesss from 'src/components/upload/UploadsSingleFilesss';
import { MButton } from 'src/components/@material-extend';
import FullScreenDialogPurchaseOrder from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogPurchaseOrder'
import { DialogAnimate } from 'src/components/animate';
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import { supabase } from '../../supabase/supabaseClient';
import DesignOrderList from './DesignOrderList';
import SplitEstimateCard from 'src/components/_dashboard/official-request/SplitEstimateCard';

const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { color: 'warning', label: 'Status: Draft' };
    case 2:
      return { color: 'info', label: 'Status: Open' };
    case 3:
      return { color: 'primary', label: 'Status: Evaluating' };
    case 4:
      return { color: 'success', label: 'Status: Accepted' };
    case 5:
      return { color: 'warning', label: 'Status: Closed' };
    case 6:
      return { color: 'error', label: 'Status: Rejected' };
    default:
      return { color: 'default', label: 'Status: Open' };
  }
};

const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' }
]
// const ACCOUNT_TABS = [
//   {
//     value: 'ALL',
//     name: 'ALL',
//     // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 1)?.length || 0
//   },
//   {
//     value: 'OPEN',
//     name: 'OPEN',
//     // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
//   },
//   {
//     value: 'ACCEPTED',
//     name: 'ACCEPTED',
//     // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
//   },
//   {
//     value: 'INSTALLATION',
//     name: 'INSTALLATION',
//     // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
//   },
// ]
const ACCOUNT_TABS = [
  {
    value: 'All',
    name: 'All',
    // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 1)?.length || 0
  },
  {
    value: 'Open',
    name: 'Open',
    // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 1)?.length || 0
  },
  {
    value: 'Approved',
    name: 'Approved',
    // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
  },
  {
    value: 'Rejected',
    name: 'Rejected',
    // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
  },
]

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative', 
      height: '100px', 
      overflow: 'hidden'
  },
  attachmentIcon: {
      marginRight: theme.spacing(1),
  },
  delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
  checkbox: {
      position: 'absolute',
      top: theme.spacing(1), 
      right: theme.spacing(1), 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
  },
  dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
  },
  gridContainer: {
      height: 'auto',
  },
}));

//sorting
const SORT = [
  { id: 'new', label: 'Newest', color: '#54D62C' }, 
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
];
  const CustomTab = styled(Tab)(({ theme }) => ({
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    boxShadow: 'none', //theme.shadows[5],
    minHeight: 'fit-content',
    indicator: {
      display: 'none',
    },
    height: 38,
    fontSize: 12,
    borderRadius: 'none', //20
    border: '1.5px solid #00c2ff', //newlyadded
    background: '#161c24',
    margin: 0, //5
    color: theme.palette.text.primary,
    '&:hover': {
      background: '#161c24',
    },
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '&:first-child': {
      borderRadius: '7px 0 0 7px',
      borderLeft: `1.5px solid ${theme.palette.primary.main}`,
    },
    '&:nth-child(2)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:nth-child(3)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:last-child': {
      borderRadius: '0 7px 7px 0',
      borderLeft: '0',
    },
  
    [theme.breakpoints.up('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: `0 !important`,
      minWidth: '30.33% !important',
    },
  }))
export default function SplitEstimate() {
  const theme = useTheme()
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [searching, setSearching] = useState(null)
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState(0);
  const [preview, setPreview] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [totalCount, setTotalCount] = useState(0)
  const [allRequest, setAllRequest] = useState([])
  const [skillServices, setSkillServices] = useState([])
  const [allProducts, setAllproducts] = useState([])
  const [materials, setMaterials] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [filteredServices, setFilteredServices] = useState([])
  const [requestTeam, setRequestTeam] = useState([])
  const [openPreview, setOpenPreview] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  const [avatarUrl, setAvatarUrl] = useState([]);
  const [filesUpload, setFilesUpload] = useState([]);
  const [location, setLocation] = useState(false);
  const [projectTypes, setProjectTypes] = useState([]);
  const [workflow, setWorkFlow] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [locationStates, setLocationStates] = useState({});
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [address, setAddress] = useState({ 23: [{ '0': { address: 'addd', city: 'fsdasadf', state: 'fsd', zip: 1654 } }] }); // 23:[{address:'sdfsdf',city:'fsdasadf',state:'fsd',zip:1654}]
  const [progress, setProgress] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().unix());
  let user = JSON.parse(localStorage.getItem('user'))
  const userType = user.user_type
  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission = explodedPermissions?.some(permission => ['View Markup'].includes(permission)) ? true : false
  const refCommunities = useRef(null);
  const [allClients, setAllClients] = useState([])
  const [communitiesOpen, setCommunitiesOpen] = useState(false);
  const [communitiesData, setCommunitiesData] = useState([]);
  const [filterCommunity, setFilterCommunity] = useState([]);
  const [markupType, setMarkupType] = useState();
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [showServices, setShowServices] = useState(false)
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false));
  const [currentTab, setCurrentTab] = useState('All')
  const [whereCondition, setWhereCondition] = useState('sp.status != 0 AND sp.status != 4')
  const [loadingCards, setLoadingCards] = useState(false)
  const [sortOpen, setSortOpen] = useState(false);
  const refSort = useRef(null);
  const [sort,setSort]=  useState(SORT[0])
  const [filterDateValue,setFilterDateValue]=  useState([null, null]);
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const [filePreview, setFilePreview] = useState(null);
  const [singleFile, setSingleFile] = useState(null);
  const fileInputRef = useRef();
  const purchaseOrderOpenProductionPopup= localStorage.getItem("purchaseOrderOpenProductionPopup")
  const [openPurchaseOrder, setOpenPurchaseOrder] = useState(purchaseOrderOpenProductionPopup||false);
  const [purchaseOrderId, setPurchaseOrderId] = useState(false);
  const [PurchaseOrderName, setPurchaseOrderName] = useState(false);
  const [isEditPurchaseOrder, setIsEditPurchaseOrder] = useState(false);
  const [renderCard,setRenderCard] = useState(false);
      const [valueTab,setTabValue] = useState('one')
  // const [userId, setUserId] = useState(() => {
  //   const storedUser = JSON.parse(localStorage.getItem('user'));
  //   return storedUser ? storedUser.user_id : null;
  // });
    const handleChangeGrid = (event, newValue) => {
    setTabValue(newValue);
  };
  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [indexCounter, setIndexCounter] = useState(0);
  const [splitPercentage, setSplitPercentage] = useState(0);
  const [otherInstallationSplitManagementSettings, setOtherInstallationSplitManagementSettings] = useState([]);
  const [productRows, setProductRows] = useState([{ indexId: 0, product_name: '',split_percentage: splitPercentage}]);
  const handleOpenViewPurchaseOrder = (id, name) => {
    setIsEditPurchaseOrder(true)
    setPurchaseOrderId(id)
    setPurchaseOrderName(name)
    setOpenPurchaseOrder(true)
    localStorage.setItem('purchaseOrderProjectId', id)
    localStorage.setItem('purchaseOrderProjectName', name)
    localStorage.setItem('isEditPurchaseOrder', 'true')
    localStorage.setItem('purchaseOrderOpenPopup', 'true')
  }

  const addNewProductRow = () => {
    const newIndexCounter = indexCounter + 1;
    setIndexCounter(newIndexCounter);
    
    const newProduct = {
      indexId: newIndexCounter,
      product_name: '',
      split_percentage: splitPercentage
    };
    
    setProductRows((prevRows) => [...prevRows, newProduct]);
  };

  const handleDeleteProduct = (indexId) => {
    if (productRows.length > 1) {
      setProductRows((prevRows) => prevRows.filter(row => row.indexId !== indexId));
    }
  };

  const handleProductNameChange = (indexId, value) => {
    setProductRows((prevRows) => 
      prevRows.map(row => 
        row.indexId === indexId ? { ...row, product_name: value } : row
      )
    );
  };
  const handleOpenDetailsPurchaseOrder = (id, name) => {
    setIsEditPurchaseOrder(false)
    setPurchaseOrderId(id)
    setPurchaseOrderName(name)
    setOpenPurchaseOrder(true)
    localStorage.setItem('purchaseOrderProjectId', id)
    localStorage.setItem('purchaseOrderProjectName', name)
    localStorage.setItem('isEditPurchaseOrder', 'false')
    localStorage.setItem('purchaseOrderOpenPopup', 'true')
  }
  useEffect(() => {
    if (selectedProducts.length <= 0) {
      setAllLocationSame(false)
    }
    console.log("useeffet log 1")
  }, [selectedProducts])
  const VALUE = [
    { id: 0, value: 'Products' },
    //  { id: 10, value: 'Product formula cost (Material cost + Service cost with markup)' },

    // { id: 10, value: 'Product formula cost' },
    { id: 1, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    { id: 2, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    // { id: 3, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 4, value: 'Unit' },
     { id: 5, value: 'Quantity' },
    //  { id: 6, value: 'Location' },
    // { id: 7, value: 'Discount' },
    { id: 8, value: 'Subtotal' },
    { id: 9, value: '' }
  ];

    const MATERIAL_VALUE = [
    { id: 0, value: 'Materials' },
    //  { id: 10, value: 'Product formula cost (Material cost + Service cost with markup)' },

    // { id: 10, value: 'Product formula cost' },
    { id: 1, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    { id: 2, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    // { id: 3, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 4, value: 'Unit' },
     { id: 5, value: 'Quantity' },
    //  { id: 6, value: 'Location' },
    // { id: 7, value: 'Discount' },
    { id: 8, value: 'Subtotal' },
    { id: 9, value: '' }
  ];

  const VALUEPreview = [
    { id: 0, value: 'Products' },
    // { id: 9, value: 'Product formula cost' }, // (Material cost + Service cost with markup)
    { id: 1, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    { id: 2, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    // { id: 3, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 4, value: 'Unit  ' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Discount' },
    { id: 7, value: 'Subtotal' },
    { id: 8, value: '' }
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Service Name' },
    { id: 1, value: 'Markup (%)' },
    { id: 2, value: 'Cost (Hourly)' },
    // { id: 6, value: 'Markup Cost (Hourly)' },
    // { id: 3, value: 'Hours' },
    { id: 4, value: 'Total cost' },
    { id: 5, value: '' }
  ];

  // const [expandedCommunities, setExpandedCommunities] = useState({});

  // const handleExpandToggle = (community) => {
  //   setExpandedCommunities(prevState => ({
  //     ...prevState,
  //     [community]: !prevState[community]
  //   }));
  // };

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    facility_type: Yup.object().nullable().required('Facility is required'),
  });
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }));
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  const load = useLocation().state
  //get All request 
  const fetchAllRequest = async () => {
    setLoadingCards(true)
    try {
      let user = JSON.parse(localStorage.getItem('user'))
      let userType = user.user_type
      let userId = user.user_id

      const values = {
        userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching,
        sort:sort.id,
        where:whereCondition,
      }
      await axios.post(`${REST_API}webservice/request/fetch-all-split-estimates`, values)
        .then((res) => {
          setAllRequest(res?.data?.result)
          setTotalCount(res?.data?.totalCount || 0)
          const otherInstallationData = res?.data?.otherInstallationSplitManagementSettings
          setOtherInstallationSplitManagementSettings(otherInstallationData || [])
          // const currentFacilitySplitManagementSettings = res?.data?.currentFacilitySplitManagementSettings
          // const currentSplitPercentage = currentFacilitySplitManagementSettings?.filter(setting => setting?.id == currentFacilityId)
          // setSplitPercentage(currentSplitPercentage[0]?.split_percentage || 0)
        })
        .catch((errors) => {
          console.log(errors, 'error in fetching all requests')
        })
    }catch(error){
      console.log("fetchAllRequest error : ",error)
    }finally{
      setLoadingCards(false)
    }
  }

  useEffect(() => {
    fetchAllRequest()
    console.log("useeffet log 2")
  }, [open, searching, page, rowsPerPage,sort,filterDateValue,renderCard,whereCondition,])
useEffect(() => {
  if(renderCard){
    setPurchaseOrderId('')
      setPurchaseOrderName('')
      setIsEditPurchaseOrder(false)    
      }
      console.log("useeffet log 3")
}, [renderCard])

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(allRequest);
    const [movedItem] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, movedItem);

    setAllRequest(reorderedItems);

    
    saveNewOrder(reorderedItems);
  };


  const saveNewOrder = async (reorderedItems) => {
    try {
      // await axios.post(`${REST_API}webservice/proposal/save-order`, { reorderedItems });
      console.log('Order saved successfully');
    } catch (error) {
      console.error('Error saving order:', error);
    }
  };

  const fetchAllCommunityByClient = async (clientId) => {
    console.log("####################ClientIs", clientId);
    try {
      clientId = clientId.id
      const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId })
      let data = res.data?.community
      await setCommunities(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }
  }


  const fetchAllClients = async () => {

    try {
      const res = await axios.post(`${REST_API}webservice/clients/getAllClients`, { userType, userId: user.user_id,isVendor:1 ,order:true})
      let data = res.data?.customer
      data=data?.filter(cust=>cust.status==1)
      await setAllClients(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/get-data-for-add-project`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.status === 1) {
          setProjectTypes(response.data.projectTypes)
          setProjectCategories(response.data.projectCategories)
          setCommunities(response.data.community)
        }
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
    fetchTaxCategory();
    fetchAllClients();
    console.log("useeffet log 4")
  }, [])

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const calculateTotal = (price, quantity, discount,location=1) => {
    const parsedQuantity = parseFloat(quantity) || 1;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity=parseFloat(location)||1
    const subtotal = price * parsedQuantity*locationQuantity;
    if (discount) {
      const totalDiscount = subtotal - discount;
      return totalDiscount;
    } else {
      return subtotal;
    }
  };



  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function applySortFilter(array, comparator, community) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    // Filter based on the community parameter
    if (community && community?.length > 0) {
      if (community?.includes('other')) {
        array = array?.filter((item) => item?.community === null || community?.includes(item?.community));
      } else {
        array = array?.filter((item) => community?.includes(item?.community));
      }
    }
    return array;
  }


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      description: '',
      facility_type: null,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        let user = JSON.parse(localStorage.getItem('user'));
        const userType = user.user_type;
        const userId = user.user_id;
        
        values.avatarUrl = avatarUrl;
        const requestData = {
          values,
          userId,
          userType,
          currentFacilityId :currentFacilityId,
          selectedRecipes : productRows,
          splitPercentage : splitPercentage
        };
          await axios.post(`${REST_API_END_POINT}request/add-split-estimate`, requestData)
            .then((res) => {
              setOpen(false);
              resetForm();
              setAvatarUrl([]);
              setProductRows([{ indexId: 0, product_name: '' }]);
              setIndexCounter(0);
              enqueueSnackbar('Split Estimate created successfully', { variant: 'success' });
            })
            .catch((errors) => {
              console.log(errors, 'error');
            });
        // }
      } catch (error) {
        console.error(error);
      }
    }

  });
  let totalAmount = 0;
 

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;
  useEffect(() => {
    setPreview(values)
    console.log("useeffet log 5")
  }, [openPreview])
 



  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order'
      );
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        });
        return;
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploading(true);

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `split-estimates/${fileName}`;

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          const {
            data: publicUrlData,
            error: urlError,
          } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);
        setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
      } catch (error) {
        console.error('Upload error:', error.message);
        enqueueSnackbar('Upload failed: ' + error.message, { variant: 'error' });
      } finally {
        setIsUploading(false);
      }
    },
    [explodedPermissions, user, setAvatarUrl, setIsUploading]
  );

const handleImage = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0]
      if(file){
        const localURL = URL.createObjectURL(file);
        setFilePreview({
          type: file.type,        // so we know if it's an image/pdf/etc.
          url: localURL
        });


        const Filename = new Date().getTime() + file.name;
  
        const StorageRef = ref(storage, Filename);
        const uploadTask = uploadBytesResumable(StorageRef, file);
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          },
          (error) => {
            console.error(error.message);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              setFieldValue('files_upload', downloadURL);          
            });
          }
        );
      }
    },
    [setFieldValue],
  )
  console.log('dfbdsbfsbifg',values.files_upload)
  // const validateFile = (file) => {
  //   const allowedFileTypes = ['application/pdf'];
  //   const maxFileSize = 2 * 1024 * 1024; // 2MB
  
  //   if (!allowedFileTypes.includes(file.type)) {
  
  //     return false;
  //   }
  
  //   if (file.size > maxFileSize) {
  
  //     return false;
  //   }
  
  //   return true;
  // };
  // const handleFileChange = async (event) => {
    
  //   const file = event.target.files[0];

  //   if (!file) {
  //     return;
  //   }

  //   if (!validateFile(file)) {
  //     return;
  //   }
  //   const storageRef = ref(storage, file.name);
  //   const uploadTask = uploadBytesResumable(storageRef, file);
  //   uploadTask.on(
  //     'state_changed',
  //     (snapshot) => {
  //       const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //       setUploadProgress(progress); 
  //     },
  //     (error) => {
  //       console.error(error.message);
  //       setUploadProgress(null);
  //       event.target.value = null;
  //     },
  //     () => {
  //       getDownloadURL(uploadTask.snapshot.ref).then((url) => {
  //         const newAttachment = {
  //           type: 'pdf',
  //           name: file.name,
  //           url: url,
  //         };
  //         setFieldValue('files_upload', newAttachment);
  //       }).catch((error) => {
  //         console.error(error.message);
  //       }).finally(() => {
  //         setUploadProgress(null);
  //         event.target.value = null; // Reset progress after upload completes
  //       });
  //     }
  //   );
  // };
  const validateFile = (file) => {
    const allowedFileTypes = ['application/pdf'];
    const maxFileSize = 2 * 1024 * 1024; // 2MB
  
    if (!allowedFileTypes.includes(file.type)) {
      return false;
    }
  
    if (file.size > maxFileSize) {
      return false;
    }
  
    return true;
  };
  
  // const handleFileChange = async (event) => {
  //   const files = Array.from(event.target.files); // Get all selected files
  //   if (!files || files.length === 0) {
  //     return;
  //   }
  
  //   const validFiles = files.filter(validateFile);
  
  //   if (validFiles.length === 0) {
  //     return;
  //   }
  
  //   const newAttachments = [];
  //   setUploadProgress(0); // Reset progress for multiple uploads
  
  //   validFiles.forEach((file) => {
  //     const storageRef = ref(storage, file.name);
  //     const uploadTask = uploadBytesResumable(storageRef, file);
  
  //     uploadTask.on(
  //       'state_changed',
  //       (snapshot) => {
  //         const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //         setUploadProgress(progress); // Update progress for current file
  //       },
  //       (error) => {
  //         console.error(error.message);
  //         setUploadProgress(null);
  //       },
  //       async () => {
  //         try {
  //           const url = await getDownloadURL(uploadTask.snapshot.ref);
  //           const attachment = {
  //             type: 'pdf',
  //             name: file.name,
  //             url: url,
  //           };
  //           newAttachments.push(attachment);
  //         } catch (error) {
  //           console.error(error.message);
  //         } finally {
  //           if (newAttachments.length === validFiles.length) {
  //             // Update state after all files are processed
  //             setFieldValue('files_upload', [...(values.files_upload || []), ...newAttachments]);
  //             setUploadProgress(null);
  //             event.target.value = null;
  //           }
  //         }
  //       }
  //     );
  //   });
  // };
  
  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    // keep only valid files
    const validFiles = files.filter(validateFile);
    if (!validFiles.length) return;

    setUploadProgress(0);                                   // reset bar / spinner

    // one promise per file
    const uploadPromises = validFiles.map(async (file, idx) => {
      const ts = Date.now();
      const cleanName = file.name.replace(/\s+/g, '_');
      const fileName = `${ts}_${cleanName}`;
      const filePath = `purchasing/proposals/attachments/${fileName}`; // ← new path

      try {
        // ------- upload to Supabase Storage -------
        const { error: upErr } = await supabase
          .storage
          .from('signwise-attachments')                     // bucket
          .upload(filePath, file);

        if (upErr) throw upErr;

        // ------- get public URL -------
        const { data, error: urlErr } = supabase
          .storage
          .from('signwise-attachments')
          .getPublicUrl(filePath);

        if (urlErr || !data?.publicUrl) throw urlErr ?? new Error('URL generation failed');

        // update simple overall progress
        setUploadProgress(Math.round(((idx + 1) / validFiles.length) * 100));

        return { type: 'pdf', name: file.name, url: data.publicUrl };
      } catch (err) {
        console.error('Upload failed:', err.message);
        return null;                                        // skip failed file
      }
    });

    // wait for all uploads
    const newAttachments = (await Promise.all(uploadPromises)).filter(Boolean);

    if (newAttachments.length) {
      setFieldValue('files_upload', [
        ...(values.files_upload || []),
        ...newAttachments,
      ]);
    }

    setUploadProgress(null);
    event.target.value = null;                              // reset input
  };

  const handleRemoveAll = () => {
    setAvatarUrl([]);
  };
  //  console.log({avatarUrl},'--------avt')
  const handleRemove = (file) => {
    // console.log(file, '--------file');
    const filteredItems = avatarUrl.filter((_file) => _file !== file);
    setAvatarUrl(filteredItems);
  };

  const handleCancel = async () => {
    setOpen(false);
    formik.resetForm();
    setAvatarUrl([]);
  }
  const handleChangeTab = (event,newValue) => {
    console.log('newValue+++++++', newValue)
    if(newValue==='Open'){
      setWhereCondition('sp.status = 1')
    }else if(newValue==='Approved'){
      setWhereCondition('sp.status = 2')
    }else if(newValue==='Rejected'){
      setWhereCondition('sp.status = 3')
    }else{
      setWhereCondition('sp.status != 0 AND sp.status != 4')
    }
    setCurrentTab(newValue);
  };
  // const handleChangeTab = async (event, newValue) => {

  //   setCurrentTab(newValue);

  //   if (newValue == 'OPEN') {
  //     let user = JSON.parse(localStorage.getItem('user'))
  //     let userType = user.user_type
  //     let userId = user.user_id

  //     const values = {
  //       userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching, where: ` r.status=2`
  //     }
  //     await axios.post(`${REST_API}webservice/request/get-all-request`, values)
  //       .then((res) => {
  //         res.data.data
  //         setAllRequest(res.data.data.data)
  //         if (res?.data?.data?.totalCount) {
  //           setTotalCount(res?.data?.data?.totalCount)
  //         } else {
  //           setTotalCount(0)
  //         }
  //         setRequestTeam(res.data.requestTeam)
  //         setSkillServices(res.data.services)
  //         setWorkFlow(res.data.workflows)
  //         setAllproducts(res.data.products)
  //         setLabourCostServices(res.data.labourCostServices)
  //         setFilteredServices(res.data.labourCostServices)
  //         const othersCommunity = { id: 'other', name: 'Others' };
  //         if (res.data?.community) {
  //           setCommunitiesData([...res.data.community, othersCommunity]);
  //         } else {
  //           setCommunitiesData([othersCommunity]);
  //         }
  //       })
  //       .catch((errors) => {
  //         console.log(errors, 'error in fetching all requests')
  //       })
  //   }
  //   else if (newValue == 'ACCEPTED') {
  //     let user = JSON.parse(localStorage.getItem('user'))
  //     let userType = user.user_type
  //     let userId = user.user_id

  //     const values = {
  //       userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching,
  //       where: ` r.status=4`
  //     }
  //     await axios.post(`${REST_API}webservice/request/get-all-request`, values)
  //       .then((res) => {
  //         res.data.data
  //         setAllRequest(res.data.data.data)
  //         if (res?.data?.data?.totalCount) {
  //           setTotalCount(res?.data?.data?.totalCount)
  //         } else {
  //           setTotalCount(0)
  //         }
  //         setRequestTeam(res.data.requestTeam)
  //         setSkillServices(res.data.services)
  //         setWorkFlow(res.data.workflows)
  //         setAllproducts(res.data.products)
  //         setLabourCostServices(res.data.labourCostServices)
  //         setFilteredServices(res.data.labourCostServices)
  //         const othersCommunity = { id: 'other', name: 'Others' };
  //         if (res.data?.community) {
  //           setCommunitiesData([...res.data.community, othersCommunity]);
  //         } else {
  //           setCommunitiesData([othersCommunity]);
  //         }
  //       })
  //       .catch((errors) => {
  //         console.log(errors, 'error in fetching all requests')
  //       })
  //   }
  //   else if (newValue == 'INSTALLATION') {
  //     let user = JSON.parse(localStorage.getItem('user'))
  //     let userType = user.user_type
  //     let userId = user.user_id

  //     const values = {
  //       userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching,
  //       where: ` i.status IS NOT NULL `
  //     }
  //     await axios.post(`${REST_API}webservice/request/get-all-request`, values)
  //       .then((res) => {
  //         res.data.data
  //         setAllRequest(res.data.data.data)
  //         if (res?.data?.data?.totalCount) {
  //           setTotalCount(res?.data?.data?.totalCount)
  //         } else {
  //           setTotalCount(0)
  //         }
  //         setRequestTeam(res.data.requestTeam)
  //         setSkillServices(res.data.services)
  //         setWorkFlow(res.data.workflows)
  //         setAllproducts(res.data.products)
  //         setLabourCostServices(res.data.labourCostServices)
  //         setFilteredServices(res.data.labourCostServices)
  //         const othersCommunity = { id: 'other', name: 'Others' };
  //         if (res.data?.community) {
  //           setCommunitiesData([...res.data.community, othersCommunity]);
  //         } else {
  //           setCommunitiesData([othersCommunity]);
  //         }
  //       })
  //       .catch((errors) => {
  //         console.log(errors, 'error in fetching all requests')
  //       })
  //   }
  //   else {
  //     let user = JSON.parse(localStorage.getItem('user'))
  //     let userType = user.user_type
  //     let userId = user.user_id

  //     const values = {
  //       userType: userType, userId: userId, page: page + 1, rowsPerPage, search: searching,
  //     }
  //     await axios.post(`${REST_API}webservice/request/get-all-request`, values)
  //       .then((res) => {
  //         res.data.data
  //         setAllRequest(res.data.data.data)
  //         if (res?.data?.data?.totalCount) {
  //           setTotalCount(res?.data?.data?.totalCount)
  //         } else {
  //           setTotalCount(0)
  //         }
  //         setRequestTeam(res.data.requestTeam)
  //         setSkillServices(res.data.services)
  //         setWorkFlow(res.data.workflows)
  //         setAllproducts(res.data.products)
  //         setLabourCostServices(res.data.labourCostServices)
  //         setFilteredServices(res.data.labourCostServices)
  //         const othersCommunity = { id: 'other', name: 'Others' };
  //         if (res.data?.community) {
  //           setCommunitiesData([...res.data.community, othersCommunity]);
  //         } else {
  //           setCommunitiesData([othersCommunity]);
  //         }
  //       })
  //       .catch((errors) => {
  //         console.log(errors, 'error in fetching all requests')
  //       })
  //   }
  // };
  useEffect(() => {
    return () => {
      if (singleFile?.preview) {
        URL.revokeObjectURL(singleFile.preview);
      }
    };
    console.log("useeffet log 6")
  }, [singleFile]);
  const filteredUsers = applySortFilter(allRequest, getComparator(order, orderBy), filterCommunity);

  const handleChangeSort = (category) => {
    setSort(category);
    setSortOpen(false);
  };
  return (
    <Page title="Split Estimates: list | Sign Wise Solutions">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <HeaderBreadcrumbs
            heading= "Split Estimates" 
          />
          {((userType === 1 || (explodedPermissions?.some(permission => ['Create Request'].includes(permission)))) && !user.isVendor && open == false) ? <Box>
            <Button
              onClick={() => {
                setOpen(!open)
              }}
              variant="contained"
              startIcon={<Icon icon={plusFill} />}
            >
              Add New Split Estimate
            </Button>
          </Box> : ""}
        </Stack>
        {open ? (
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3}>

                <Grid item xs={12} md={12}>
                  <Card sx={{ p: 3 }}>
                    <CardHeader sx={{ ml: -3, mt: -4 }} title='New Split Estimate' />
                    <Stack spacing={3}>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Stack flexDirection={'column'}>

                          <TextField required
                            //   fullWidth
                            sx={{ width: 400 }}
                            label="Split Estimate Name"
                            {...getFieldProps('name')}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                          />
                        </Stack>
                      </Stack>
                      <LabelStyle>Description</LabelStyle>
                      <TextField required
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="keep the summary brief and make it communicates"
                        {...getFieldProps('description')}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                      />
                      <LabelStyle>Products</LabelStyle>
                      <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Sl No</TableCell>
                              <TableCell align="center">Product Name</TableCell>
                              <TableCell align="center"></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {productRows.map((row, index) => (
                              <TableRow key={row.indexId}>
                                <TableCell align="center">{index + 1}</TableCell>
                                <TableCell align="center">
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    value={row.product_name}
                                    onChange={(e) => handleProductNameChange(row.indexId, e.target.value)}
                                    placeholder="Product Name"
                                  />
                                </TableCell>
                                <TableCell align="center">
                                    {productRows.length > 1 && (
                                      <IconButton 
                                        onClick={() => handleDeleteProduct(row.indexId)}
                                        color="error"
                                      >
                                        <Delete />
                                      </IconButton>
                                    )}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start'}}>
                        <Button
                          variant="outlined"
                          startIcon={<Icon icon={plusFill} />}
                          onClick={addNewProductRow}
                          sx={{
                            marginLeft: '20px'
                          }}
                        >
                          Add Row
                        </Button>
                      </Box>
                      <Divider />

                      <LabelStyle>Choose Facility</LabelStyle>
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
                          sx={{ width: '50%' }}
                          id="combo-box-demo-type-single"
                          options={filteredOtherFacilityTypes || []}
                          value={values.facility_type}
                          onChange={(event, newValue) => {
                            setFieldValue('facility_type', newValue);
                            
                            // Set split percentage when facility_type matches otherInstallation ID
                            if (newValue && otherInstallationSplitManagementSettings) {
                              const matchedSetting = otherInstallationSplitManagementSettings.find(
                                setting => setting?.id == newValue.id
                              );
                              
                              if (matchedSetting) {
                                const newSplitPercentage = matchedSetting.split_percentage || 0;
                                setSplitPercentage(newSplitPercentage);
                                
                                // Update all existing product rows with the new split percentage
                                setProductRows((prevRows) => 
                                  prevRows.map(row => ({
                                    ...row,
                                    split_percentage: newSplitPercentage
                                  }))
                                );
                              }
                            } else if (!newValue) {
                              // Reset to 0 when no facility is selected
                              setSplitPercentage(0);
                              
                              // Update all existing product rows to 0
                              setProductRows((prevRows) => 
                                prevRows.map(row => ({
                                  ...row,
                                  split_percentage: 0
                                }))
                              );
                            }
                          }}
                          getOptionLabel={(option) => option?.label ?? ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          renderInput={(params) => (
                            <TextField
                              required
                              {...params}
                              label="Choose Facility"
                              placeholder="Select facility"
                              error={Boolean(touched.facility_type && errors.facility_type)}
                              helperText={touched.facility_type && errors.facility_type}
                            />
                          )}
                        />
                      </Stack>

                      <LabelStyle>Upload Files / Documents</LabelStyle>
                      <UploadMultiFile
                        showPreview
                        maxSize={15 * 1024 * 1024}
                        accept="image/*,application/pdf"
                        files={avatarUrl}
                        onDrop={handleDrop}
                        onRemove={handleRemove}
                        onRemoveAll={handleRemoveAll}
                        isUploading={isUploading}
                      />

                      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <LoadingButton type="submit" variant="contained" loading={isSubmitting}  >
                          Save Split Estimate
                        </LoadingButton>
                        {/* {(userType !== 3 && (explodedPermissions?.some(permission => ['Create Request'].includes(permission)))) && (
                          <Button variant="outlined" onClick={() => setOpenPreview(!openPreview)}>
                            Preview
                          </Button>
                        )} */}
                        <Button variant="outlined" onClick={() => handleCancel()}>
                          Cancel
                        </Button>
                      </Box>
                    </Stack>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        ) : (<>
          <Stack mb={5} direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 3, sm: 2 }} alignItems="center"
            justifyContent="space-between">

            <OfficialRequestSearch
              searching={searching}
              setSearching={setSearching}
              setAllRequest={setAllRequest} />
                <Stack flexDirection={'row'} gap={2}>
                
                <Stack>
                  <Button
                    ref={refSort}
                    onClick={() => setSortOpen((prevState) => !prevState)}
                    variant="outlined"
                    type="button"
                    endIcon={
                      <Stack>
                        {sortOpen ? <ExpandLess sx={{ ml: 'auto' }} /> : <ExpandMore sx={{ ml: 'auto' }} />}
                      </Stack>
                    }
                  >
                    {sort.label}
                  </Button>
                  <Menu
                    open={Boolean(sortOpen)}
                    anchorEl={refSort.current}
                    onClose={() => setSortOpen(false)}
                    PaperProps={{
                      sx: { width: 'auto', maxWidth: '100%', maxHeight: '250px' },
                    }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    {SORT.map((category) => (
                      <MenuItem key={category.id} onClick={() => handleChangeSort(category)}>
                        <ListItemText primary={category.label} />
                      </MenuItem>
                    ))}
                  </Menu>
                </Stack>
            </Stack>
          </Stack>
          {filterCommunity.length > 0 &&
            <>
              <Typography variant="h6" sx={{ marginTop: 2, marginBottom: 2 }}>
                <span style={{ color: theme.palette.primary.darker }}>Selected Communities : </span>
                {communitiesData
                  .filter(community => filterCommunity.includes(community.id))
                  .map(community => community.name)
                  .join(', ')
                }
              </Typography>
            </>
          }

           {/* <Stack direction={'row'} spacing={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                             
                                             <Tabs
                                               value={valueTab}
                                               onChange={handleChangeGrid}
                                               textColor="secondary"
                                               indicatorColor="none"
                                               aria-label="secondary tabs example"
                                             >
                                               <CustomTab value="one" icon={<ViewModule />} />
                                               <CustomTab value="two" icon={<ViewList />} />
                                               <CustomTab value="three" icon={<ListIcon />} />
                                             </Tabs>
                                           </Stack> */}
          <Scrollbar>
            <Grid container spacing={1}>
              <Tabs
                value={currentTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChangeTab}

              >
                {ACCOUNT_TABS.map((tabItem) => (
                  <Tab
                    sx={{
                      justifyContent: 'center', marginX: 15, mt: 2.5
                    }}
                    disableRipple
                    key={tabItem.value}
                    label={
                      // <Badge badgeContent={tabItem.count} color="primary">
                      <Typography variant='h6'>{capitalCase(tabItem.name)}</Typography>
                      // </Badge>
                    }
                    // icon={tabItem.icon}
                    value={tabItem.value}
                  />
                ))}
              </Tabs> 
              {loadingCards ? 
                <Grid container alignItems={'center'} justifyContent={'center'}>
                  <Stack sx={{my:15}}>
                    <LoadingScreen />
                  </Stack>
                </Grid>
              :
              <>
  {filteredUsers?.length > 0 ? (
   <>
      {valueTab==='one' &&<DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="officialRequests" direction="vertical">
          {(provided) => (
            <Grid
              container
              spacing={3}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {filteredUsers.map((row, index) => {
                const team_member = 
                  requestTeam?.length > 0 
                    ? requestTeam.filter((member) => member.request_id === row.id) 
                    : [];
                    const updatedData = '';
  
                return (
                  <Draggable
                    key={row.id}
                    draggableId={row.id.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{ mt: 3 }}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          opacity: snapshot.isDragging ? 0.5 : 1,
                        }}
                      >
                        <SplitEstimateCard
                          card={row}
                          setRenderCards={setRenderCard}
                          renderCards={renderCard}
                          handleOpenDetailsPurchaseOrder={handleOpenDetailsPurchaseOrder}
                          handleOpenViewPurchaseOrder={handleOpenViewPurchaseOrder}
                          isSplitEstimate={true}
                        />
                      </Grid>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </Grid>
          )}
        </Droppable>
      </DragDropContext>}
                        {valueTab === 'two' &&
                          <DesignOrderList
                            salesOrder={true}
                            estimate={true}
                            proposalView={1}
                            projectData={filteredUsers}
                            currentTab={currentTab}
                            setRenderCards={setRenderCard}
                            renderCards={renderCard}
                            handleOpenDetailsPurchaseOrder={handleOpenDetailsPurchaseOrder}
                            handleOpenViewPurchaseOrder={handleOpenViewPurchaseOrder}
                          />}
                        {valueTab === 'three' &&
                          <DesignOrderList
                            salesOrder={true}
                            estimate={true}
                            proposalView={1}
                            noImage={true}
                            projectData={filteredUsers}
                            currentTab={currentTab}
                            setRenderCards={setRenderCard}
                            renderCards={renderCard}
                            handleOpenDetailsPurchaseOrder={handleOpenDetailsPurchaseOrder}
                            handleOpenViewPurchaseOrder={handleOpenViewPurchaseOrder}
                          />}
   </>
  ) : (
    <Grid container alignItems="center" justifyContent="center">
      <Stack sx={{ my: 15 }}>
        <Typography gutterBottom align="center" variant="subtitle1">
          No {capitalCase(currentTab)} Split Estimates Found
        </Typography>
      </Stack>
    </Grid>
  )}
</>

              }
            </Grid>
          </Scrollbar>
          {loadingCards ? "" :
          <Stack gap={2} sx={{mt:2}}>
            <TablePagination
              rowsPerPageOptions={[6, 12, 27]}
              component="div"
              count={totalCount || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Stack>}
        </>)}
      </Container>
      <FullScreenDialogPurchaseOrder
        open={openPurchaseOrder}
        setOpen={setOpenPurchaseOrder}
        handleClickOpen={handleOpenViewPurchaseOrder}
        projectName={PurchaseOrderName}
        projectId={purchaseOrderId}
        isEditPurchaseOrder={isEditPurchaseOrder}
        setRenderCards={setRenderCard}
        renderCards={renderCard}
      />
    </Page>
  )
}